import React, { Component } from "react";
import { string, bool, arrayOf, oneOfType, array } from "prop-types";

class PreviewableDocument extends Component {
  static propTypes = {
    id: string.isRequired,
    label: string.isRequired,
    optional: bool,
    defaultValue: string,
    accept: arrayOf(string),
    error: oneOfType([bool, string, array]),
    inline: bool,
  };

  static defaultProps = {
    defaultValue: null,
    optional: false,
    accept: [".pdf"],
    error: null,
    inline: false,
  };

  constructor(props) {
    super(props);

    const existingDocument = props.defaultValue ? props.defaultValue : null;

    this.state = {
      documentData: existingDocument,
      errorContent: props.error,
    };

    this.onChange = this.onChange.bind(this);
  }

  /**
   * {@inheritdoc}
   */
  componentDidUpdate(prevProps) {
    const { error } = this.props;

    if (prevProps.error !== error) {
      this.setState({ errorContent: error });
    }
  }

  onChange(event) {
    event.preventDefault();

    const reader = new FileReader();
    const file = event.target.files[0];

    reader.onloadend = () => {
      this.setState({
        documentData: reader.result,
      });
    };

    this.setState({ errorContent: null });

    reader.readAsDataURL(file);
  }

  /**
   * @return {String}
   */
  get value() {
    return this.state.documentData;
  }

  /**
   * @param {String} value
   */
  set value(value) {
    this.setState({ documentData: value });
  }

  renderErrors() {
    const { errorContent } = this.state;

    if (!errorContent || typeof errorContent === "boolean") {
      return null;
    }

    return (
      <div className="invalid-feedback" style={{ display: "block" }}>
        {[].concat(errorContent).map((error) => (
          <p key={error}>{error}</p>
        ))}
      </div>
    );
  }

  /**
   * {@inheritdoc}
   */
  render() {
    const { id, label, optional, accept, inline } = this.props;

    const { documentData } = this.state;

    const document = documentData && (
      <div className="document">
        <embed
          src={documentData}
          type="application/pdf"
          frameBorder="0"
          height="100%"
          width="100%"
        ></embed>
      </div>
    );

    return (
      <div className="form-group">
        <label htmlFor={id} className="custom-file-input">
          {label}
          {optional ? "" : "*"}
        </label>
        <div className={inline ? "previewable-image" : ""}>
          {document}
          <div className="custom-file">
            <input
              type="file"
              accept={accept.join(", ")}
              className="custom-file-input"
              id={id}
              ref={(input) => {
                this.input = input;
              }}
              onChange={this.onChange}
              style={{ maxHeight: "unset" }}
            />
            {this.renderErrors()}
          </div>
        </div>
      </div>
    );
  }
}

export default PreviewableDocument;
